import { Button } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';

const CommonContent = () => {
  const { close, sheets } = useBottomSheet();
  const sheet = sheets.Common;
  const { title, description, showSkipButton = false, confirmText = brsc.leave } = sheet.data;

  return (
    <div className="flex h-full w-full flex-col items-center">
      <div className="typography-title-md text-base-txt-primary">{title}</div>
      <div className="typography-body-sm pb-6 pt-3 text-base-txt-secondary text-center">{description}</div>
      <div className="flex w-full flex-row gap-1">
        {showSkipButton && <Button onClick={() => close(sheet.id, { data: false })} style={{ text: brsc.watch_again, color: 'btn-bg-normal', fontColor: 'btn-txt-normal' }} className="w-full" />}
        <Button onClick={() => close(sheet.id, { data: true })} style={{ text: confirmText, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'full' }} className="w-full" />
      </div>
    </div>
  );
};

export default CommonContent;
